import * as nav from "./modules/navigation.js";
import * as swiper from "./modules/swiper.js";
import * as slideToggle from "./modules/slideToggle.js";
import { animateOnScroll } from "./modules/observer.js";
import * as counter from "./modules/counter.js";
import { initSearch } from "./modules/instantSearch.js";
import { initAutocomplete } from "./modules/autocomplete.js";
import { openModal, closeModal } from "./modules/modal.js";

if (document.querySelector("#hits")) {
  initSearch({
    appId: window.application_id,
    apiKey: window.search_api_key,
    indexName: window.index_name,
  });

  // Reset date filters on clear
  document.querySelector("#clear-refinements").addEventListener("click", () => {
    document.getElementById("start-date").value = "";
    document.getElementById("end-date").value = "";
  });
}

initAutocomplete({
  appId: window.application_id,
  apiKey: window.search_api_key,
  indexName: window.index_name,
});

window.addEventListener(
  "load",
  () => {
    document.body.classList.remove("preload");
  },
  false,
);

document.querySelector("#btt-button").addEventListener("click", () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
});

document.addEventListener("htmx:afterSwap", function (event) {
  // Don't scroll if the load more button triggered the request
  const requestElement = event.detail?.requestConfig?.elt;
  if (requestElement?.id === "load-more-oob") {
    return;
  }

  const scrollAnchor = document.getElementById("scrollAnchor");
  if (!scrollAnchor) {
    return;
  }

  const targetY =
    scrollAnchor.getBoundingClientRect().top + window.scrollY - 64;

  window.scrollTo(0, targetY);
});

// Lightbox
document.addEventListener("DOMContentLoaded", () => {
  document.body.addEventListener("click", (e) => {
    const target = e.target.closest(".toggle-lightbox");

    if (target) {
      e.preventDefault();

      const imageUrl = target.getAttribute("data-image");
      const lightbox = document.createElement("div");

      lightbox.className = "fixed inset-0 p-8 bg-white/90 z-50 cursor-pointer";
      lightbox.innerHTML = `
        <svg class="absolute top-4 right-4 size-4 fill-black" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path d="M16.293 17.708 9 10.415l-7.293 7.293a1 1 0 0 1-1.414-1.415L7.585 9 .293 1.707A1 1 0 0 1 1.707.293L9 7.585 16.293.293a1 1 0 0 1 1.415 1.415L10.415 9l7.293 7.293a1 1 0 0 1-1.415 1.415Z"/></svg>
        <img src="${imageUrl}" class="w-full h-full object-contain">
      `;

      // Append to body
      document.body.appendChild(lightbox);
      openModal();

      // Close lightbox on click
      lightbox.addEventListener("click", () => {
        lightbox.remove();
        closeModal();
      });
    }
  });
});

// Auto load more
function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
  );
}

function handleScroll() {
  const button = document.querySelector("#load-more-oob");
  if (button && isInViewport(button)) {
    button.click();
  }
}

window.addEventListener("scroll", handleScroll);
window.addEventListener("load", handleScroll);
